import {
  ADD_BRAND,
  ADD_BRAND_ERROR,
  ADD_BRAND_START,
  UPDATE_BRAND,
  UPDATE_BRAND_ERROR,
  UPDATE_BRAND_START,
  GET_BRAND,
  GET_BRAND_ERROR,
  GET_BRAND_LIST_PAGEABLE,
  GET_BRAND_LIST_PAGEABLE_START,
  GET_BRAND_LIST_PAGEABLE_ERROR,
  DELETE_BRAND,
  DELETE_BRAND_ERROR,
  DELETE_BRAND_START,
  CLEAR_ERROR_BRAND,
  GET_BRAND_LIST,
  GET_BRAND_LIST_ERROR,
  GET_BRAND_LIST_START,
} from '../actions/types';

const initialState = {
  emptyList: false,
  brandList: [],
  brand: {},
  loading: false,
  error: undefined,
  totalElements: '',
  pageNumber: -1,
  pageSize: 8,
  isLastPage: false,
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addBrandStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addBrandError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addBrand = (state, action) => {
  return {
    ...state,
    loading: false,
    brandList: state.brandList.concat(action.payload),
  };
};

const updateBrandStart = (state) => {
  return {
    ...state,
  };
};

const updateBrandError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateBrand = (state, action) => {
  return {
    ...state,

    brandList: state.brandList.map((brand) =>
      brand.id === action.payload.id ? action.payload : brand
    ),
    loading: false,
  };
};

const findAllBrandsPageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllBrandsPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllBrandsPageable = (state, action) => {
  return {
    ...state,
    brandList: [...action.payload.list],
    totalElements: action.payload.totalElements,
  };
};

const deleteBrandStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteBrandError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteBrand = (state, action) => {
  return {
    ...state,
    loading: false,
    brandList: state.brandList.filter(
      (brand) => brand.id !== action.payload
    ),
  };
};

const findBrandByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findBrandByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findBrandById = (state, action) => {
  return {
    ...state,
    loading: false,
    userRole: action.payload,
  };
};

const findAllBrandsStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllBrandsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllBrands = (state, action) => {
  return {
    ...state,
    loading: false,
    brandList: action.payload,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_BRAND:
      return addBrand(state, action);
    case ADD_BRAND_START:
      return addBrandStart(state);
    case ADD_BRAND_ERROR:
      return addBrandError(state, action);

    case UPDATE_BRAND:
      return updateBrand(state, action);
    case UPDATE_BRAND_START:
      return updateBrandStart(state);
    case UPDATE_BRAND_ERROR:
      return updateBrandError(state, action);

    case GET_BRAND:
      return findBrandById(state, action);
    case GET_BRAND_LIST_START:
      return findBrandByIdStart(state);
    case GET_BRAND_ERROR:
      return findBrandByIdError(state, action);

    case GET_BRAND_LIST_PAGEABLE_START:
      return findAllBrandsPageableStart(state, action);
    case GET_BRAND_LIST_PAGEABLE:
      return findAllBrandsPageable(state, action);
    case GET_BRAND_LIST_PAGEABLE_ERROR:
      return findAllBrandsPageableError(state, action);

    case DELETE_BRAND:
      return deleteBrand(state, action);
    case DELETE_BRAND_START:
      return deleteBrandStart(state);
    case DELETE_BRAND_ERROR:
      return deleteBrandError(state, action);
    case CLEAR_ERROR_BRAND:
      return clearError(state);

    case GET_BRAND_LIST:
      return findAllBrands(state, action);
    case GET_BRAND_LIST_START:
      return findAllBrandsStart(state);
    case GET_BRAND_LIST_ERROR:
      return findAllBrandsError(state, action);

    default:
      return state;
  }
}
